import { Prompt } from '../services/api';

export const isSystemPrompt = (prompt: Prompt): boolean => prompt.user_id === 'system';

export const getSystemPrompts = (prompts: Prompt[]): Prompt[] => (
  prompts.filter(isSystemPrompt)
);

export const getSystemDefaultPrompt = (
  prompts: Prompt[],
  defaultPromptId?: string | null,
): Prompt | null => {
  const systemPrompts = getSystemPrompts(prompts);
  const normalizedDefaultPromptId = String(defaultPromptId || '').trim();
  if (normalizedDefaultPromptId) {
    const exactMatch = systemPrompts.find((prompt) => prompt.prompt_id === normalizedDefaultPromptId);
    if (exactMatch) {
      return exactMatch;
    }
  }
  return systemPrompts[0] || null;
};

export const resolvePromptSelection = (
  prompts: Prompt[],
  preferredPromptId: string | null | undefined,
  defaultPromptId?: string | null,
): Prompt | null => {
  const normalizedPromptId = String(preferredPromptId || '').trim();
  if (normalizedPromptId) {
    const exactMatch = prompts.find((prompt) => prompt.prompt_id === normalizedPromptId);
    if (exactMatch) {
      return exactMatch;
    }
  }
  return getSystemDefaultPrompt(prompts, defaultPromptId);
};
